<script>
  import { onMount } from "svelte";
  import request from 'superagent';
  
  import Astro from './Astro.svelte';
  import Text from './../../../../components/forms/Text.svelte';
  import ParentedData from './../../../../components/forms/ParentedData.svelte';
  import Data from './../../../../components/forms/Data.svelte';
  
  export let chmu_summary_form_id = window.chmu_summary_form_id;
  export let yrno_cityhours_form_id = window.yrno_cityhours_form_id;
  
  
  let chmu_text_visible = false, chmu_aladin_visible = true;
  
  let visible_panel_index = null;
  
  let aladin_metric = "T2m"; // "prec"
  let aladin_speed = "500";
  let aladin_gif = false;
  let aladin_animated = false;
  let aladin_images = [];
  let aladin_image_index = 0;
  let aladin_progress_start = 0;
  
  $: aladin_gif = aladin_images[aladin_image_index];
  
  let hour_forecast_group_size = 6;
  
  //let temp_chart_values = null;
  
  let user = null;
  
  /*let week_says = (){
    var baseDate = new Date();
    var weekDays = [];
    for(i = 0; i < 7; i++)
    {
        weekDays.push(baseDate.toLocaleDateString('CZ_cs', { weekday: 'long' }));
        baseDate.setDate(baseDate.getDate() + 1);
    }
    return weekDays;
  }()*/
  
  function range(start, stop, step) {
    var a = [start], b = start;
    while (b < stop) {
        a.push(b += step || 1);
    }
    return a;
  }
  
  function aladinImages() {
    let images = [];
    let now = new Date();
    let nowHours = now.getHours();
    now.setHours(nowHours - 1);
    let daystr = now.getFullYear() + ('0' + (now.getMonth()+1)).slice(-2) + ('0' + now.getDate()).slice(-2) + (nowHours > 15 ? '12' : '00');
    aladin_progress_start = nowHours > 15 ? 15 : 3;
    let start = 3, stop = 27, step = 3;
    range(start, stop, step).forEach((i) =>
      images.push(`/files/portal/docs/meteo/ov/aladin/results/public/mapy/data/${daystr}/${aladin_metric}_public_${('0' + i).slice(-2)}.png`)
    )
    return images
  }
  
  function forecastGrouping(items, operator, update_at) {
    if ((Array.isArray(items) && !items.length) || 0 == Object.keys(items).length)
      return items;
  
    let finalItems = [];
    let it = items;
    //temp_chart_values = items["temperature_2m"];
    for(let i = 0; i < it["time"].length; i++) {
      finalItems.push({
        time: it["time"][i],
        temp_c: it["temperature_2m"][i],
        precip_mm: it["precipitation"][i],
        cloud: it["cloud_cover"][i],
        code: it["weather_code"][i]
      });
    }
    return finalItems;
  }
  
  /*function hourForecastGrouping(items, operator, updated_at) {
    if (!items || !items.length)
      return items;
    let finalItems = [];
    let day_values = {}, night_values = {};
    let period_counter = 0;
    let items_counter = 0;
  
    for(let i = 0; i < items.length; i++) {
      var time = new Date(items[i].time);
      // time.setHours(time.getHours()+i);
      var day = time.getDay();
      items[i]["day"] = day;
      var hour = time.getHours();
      if (hour >= 7 && hour < 21) {
        if ((day_values[day] || items[i].temp_c) <= items[i].temp_c)
          day_values[day] = items[i].temp_c;
      } else {
        if ((night_values[day] || items[i].temp_c) >= items[i].temp_c)
          night_values[day] = items[i].temp_c;
      }
    }
    for(let i = 0; i < items.length; i++) {
      var day = items[i]["day"]
      items[i].d_temp_c = day_values[day];
      items[i].n_temp_c = night_values[day];
    }
    for(let i = 0; i < items.length; i++) {
      ++items_counter;
  
      if (finalItems.length <= period_counter)
        finalItems.push({...items[i]});
  
      if (new Date(items[i].time).getHours() % (operator || hour_forecast_group_size) == 0) {
        items_counter = 0;
        ++period_counter;
      }
    }
  
    return finalItems;
  }*/
  
  function toggleHourForecastPanelVisibility(index) {
    visible_panel_index = visible_panel_index == index ? null : index;
  }
  
  function checkHourForecastPanelVisibility(index, init) {
    var time = new Date(init)
    var day = visible_panel_index / 4 + 1;
    console.log(index, init, day, time.getDay())
    //visible_time.setHours(init.getHours()+visible_panel_index*hour_forecast_group_size);
    //time.setHours(init.getHours()+index*hour_forecast_group_size);
    return day == time.getDay()
  }
  
  function toggleAladin() {
    if (aladin_animated === false)
      aladin_animated = setInterval(function() {
        aladin_image_index++;
        if (aladin_image_index >= aladin_images.length)
          aladin_image_index = 0;
        aladin_gif = aladin_images[aladin_image_index];
      }, parseInt(aladin_speed));
    else {
      clearInterval(aladin_animated);
      aladin_animated = false;
    }
  }
  
  function showAladin(a) {
    chmu_aladin_visible = a
    chmu_text_visible = false
    if (chmu_aladin_visible == 1)
      aladin_metric = "T2m";
    if (chmu_aladin_visible == 2)
      aladin_metric = "prec";
    aladin_images = aladinImages();
  }
  
  function showText() {
    chmu_aladin_visible = 0
    chmu_text_visible = true
  }
  
  async function createGif() {
    if (aladin_animated === false) {
      aladin_images = aladinImages();
      aladin_gif = aladin_images[0];
      return;
    }
      /*window.gifshot.createGIF({
        images: aladinImages(),
        frameDuration: 23,
        numFrames: 15,
        gifWidth: 600,
        gifHeight: 362
      }, function(obj) {
        if(!obj.error)
          aladin_gif = obj.image;
      });*/
  }
  
  onMount(function() {
    createGif();
    getUser();
  });
  function getUser() {
    fetch(`/user.jsr`)
      .then(function(r) {
        if (r.ok) return r;
        if (r.code != 401) throw Error(r.statusText);
      })
      .then(r => r.json())
      .then(data => {
        user = data.data[0]
      })
      .catch(function(error) {
        console.log(error);
      });
  }
</script>
<nav class='navbar navbar-light bg-white justify-content-between shadow-sm'>
<ul class='nav flex-row'>
<li class='nav-item'>
<a class='nav-link' href='/' tinro-ignore title='Informační servis'>
<i class='fas fa-external-link-alt'></i>
Obsah
</a>
</li>
<li class='nav-item'>
<a class='nav-link' href='/c' tinro-ignore title='Kalendář'>
<i class='far fa-calendar-alt'></i>
Kalendář
</a>
</li>
<li class='nav-item'>
<a class='nav-link' href='/w' tinro-ignore title='Počasí ČR'>
<i class='wi wi-day-sunny-overcast'></i>
Počasí
</a>
</li>
{#if user}
<li class='nav-item'>
<a class='nav-link text-primary' href='/f' rel='nofollow' tinro-ignore title='Odběry novinek'>
<i class='fa fa-star'></i>
</a>
</li>
<li class='nav-item'>
<a class='nav-link text-primary' href='/a' rel='nofollow' tinro-ignore title='Strojová analýza textového obsahu'>
<i class='fa fa-graduation-cap'></i>
</a>
</li>
<li class='nav-item'>
<a class='nav-link text-success' href='/nlp' rel='nofollow' tinro-ignore title='Tvorba analytických modelů'>
<i class='fa fa-chalkboard-teacher'></i>
</a>
</li>
<li class='nav-item'>
<a class='nav-link text-success' href='/kb' rel='nofollow' tinro-ignore title='Znalostní báze'>
<i class='fa fa-book'></i>
</a>
</li>
<li class='nav-item'>
<a class='nav-link text-success' href='/e' rel='nofollow' tinro-ignore title='Editor'>
<i class='fa fa-edit'></i>
</a>
</li>
{/if}
<li class='nav-item'>
<a class='nav-link' href='/info' rel='nofollow' tinro-ignore>
<i class='fa fa-info'></i>
</a>
</li>
</ul>
<ul class='nav flex-row'>
{#if user}
<li class='nav-item'>
<a class='nav-link text-primary' href='/profile' rel='nofollow' tinro-ignore title='Nastavení'>
<i class='fa fa-cog'></i>
</a>
</li>
{:else}
<li class='nav-item'>
<a class='nav-link text-primary' href='/html/account.html' rel='nofollow' tinro-ignore>Přihlášení</a>
</li>
{/if}
</ul>

</nav>
<div class='container-fluid'>
<div class='d-flex flex-row'>
<div class='row my-2 w-100'>
<div class='container-fluid d-flex flex-column min-vh-100 justify-content-start'>
<div class='row'>
<div class='col-8'>
<h5>
<select class='display-6' disabled>
<option selected>Česká republika</option>
</select>
</h5>
<ul class='nav nav-pills mb-3'>
<li class='nav-item' on:click='{() => showAladin(1)}'>
<div class:active='{chmu_aladin_visible == 1}' class='nav-link'>
Aladin - teplota
</div>
</li>
<li class='nav-item' on:click='{() => showAladin(2)}'>
<div class:active='{chmu_aladin_visible == 2}' class='nav-link'>
Aladin - srážky
</div>
</li>
<li class='nav-item' on:click='{showText}'>
<div class:active='{chmu_text_visible}' class='nav-link'>
Zpráva ČHMÚ
</div>
</li>
</ul>
<div class:d-none='{!chmu_text_visible}' class='bg-white shadow rounded' id='chmu_text'>
<div class='card'>
<div class='card-body'>
<Text form_id='{chmu_summary_form_id}'></Text>
</div>
</div>
</div>
<div class:d-none='{!chmu_aladin_visible}' class='bg-white shadow p-2 rounded' id='chmu_aladin_gif'>
<div class='card border-0'>
<div class='d-flex flex-row justify-content-between mb-2'>
<div class='btn btn-outline-link' on:click='{toggleAladin}' title='Animace'>
<i class:fa-pause='{aladin_animated}' class:fa-play='{!aladin_animated}' class='fa'></i>
</div>
<div class='w-75'>
<input bind:value='{aladin_image_index}' class='custom-range' id='animatedAladin' max='{aladin_images.length - 1}' min='0' type='range'>
<div class='d-flex flex-row justify-content-between w-100'>
{#each range(aladin_progress_start, aladin_progress_start+24, 3) as h}
<div class='flex-fill-sm'>
{h % 24}
</div>
{/each}
</div>
</div>
</div>
<img alt='animated aladin map' class='img-fluid w-100' src='{aladin_gif}'>
</div>
</div>
</div>
<div class='col-4'>
{#each [hour_forecast_group_size] as hour_forecast_group_size}
<div class='bg-white'>
<ParentedData data_key='hourly' form_id='{yrno_cityhours_form_id}' itemsForPrintFn='{forecastGrouping}' operator='{hour_forecast_group_size}'>
<div let:index='{index}' let:item='{item}' let:updated_at='{updated_at}' slot='body'>
<Astro expanded='{visible_panel_index != null && ((visible_panel_index/8) >> 0) == ((index/8) >> 0)}' init='{updated_at}' item='{item}' on:toggle='{() => toggleHourForecastPanelVisibility(index)}'></Astro>
</div>
<div slot='head'>
</div>
</ParentedData>
</div>
{/each}
</div>
</div>
<div class='row mt-5'>
<div class='col-12'>
Zdroje pro tuto stránku:
<ul class='list-group list-group-horizontal text-center'>
<li class='list-group-item media'>
<div class='media-body'>
http://portal.chmi.cz
</div>
<img alt='Licence: CC' src='/img/cc.png' width='40px'>
</li>
<li class='list-group-item media'>
<div class='media-body'>
https://weatherapi.com
</div>
</li>
<li class='list-group-item media'>
<div class='media-body'>
https://open-meteo.com
</div>
</li>
</ul>
</div>
</div>
</div>

</div>
</div>
</div>
